import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/salary-grades/new/loading';

export const Route = createFileRoute('/_private/settings/salary-grades/new')({
  component: Loading,
});
